import { LabMDM } from "./lab";
import { OperetionHistoryDTO } from "./operationHistory";

export class ProcessFlow{

  _id: string;
  processFlowName:string;
  lab:LabMDM;
  sampleType: string;
  beadChipSize : number;
  aliqoutVolume: number;
  existenceCheck : boolean ;
  plateReception : boolean ;
  singleReception : boolean ;
  manualReception : boolean ;
  automaticReception : boolean ;
  qcScan : boolean ;
  okTOpureHair : boolean ;
  okTOpureEartag : boolean ;
  ExEartagTLR : boolean ;
  qcNanodrop : boolean ;
  detailedWorkflow: boolean;
  merge96: boolean;
  illuminaExInfinium : boolean ;
  axiom384Propel : boolean ;
  manualPreparation : boolean ;
  precell : boolean ;
  manualPost : boolean ;
  resultEvaluation: boolean;
  active : boolean ;
  history:OperetionHistoryDTO[];
}
